export default __webpack_public_path__ + "static/media/agustin1.852d6282.png";